var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8787 3H3.2C2.0799 3 1.51984 3 1.09202 3.21799C0.715695 3.40973 0.409734 3.71569 0.217987 4.09202C0.0133783 4.49359 0.000821053 5.01165 5.03897e-05 6H0V6.2V8V12.8C0 13.9201 0 14.4802 0.217987 14.908C0.409734 15.2843 0.715695 15.5903 1.09202 15.782C1.09305 15.7825 1.09407 15.7831 1.0951 15.7836L1.908 14.9707C1.68095 14.9481 1.59164 14.9143 1.54601 14.891C1.35785 14.7951 1.20487 14.6422 1.10899 14.454C1.0838 14.4045 1.04612 14.3038 1.02393 14.0322C1.00078 13.7488 1 13.3766 1 12.8V8H8.87868L10.8787 6H1.00007C1.00051 5.5349 1.00357 5.21698 1.02393 4.96784C1.04612 4.69617 1.0838 4.59545 1.10899 4.54601C1.20487 4.35785 1.35785 4.20487 1.54601 4.10899C1.59545 4.0838 1.69617 4.04612 1.96784 4.02393C2.25117 4.00078 2.62345 4 3.2 4H12.8787L13.8787 3ZM15.1213 6H17.9999C17.9995 5.5349 17.9964 5.21698 17.9761 4.96784C17.9539 4.69617 17.9162 4.59545 17.891 4.54601C17.7951 4.35785 17.6422 4.20487 17.454 4.10899C17.4084 4.08574 17.319 4.05186 17.092 4.02932L17.9049 3.21642C17.9059 3.21694 17.907 3.21746 17.908 3.21799C18.2843 3.40973 18.5903 3.71569 18.782 4.09202C18.9866 4.49359 18.9992 5.01165 19 6H19V6.2V8V12.8C19 13.9201 19 14.4802 18.782 14.908C18.5903 15.2843 18.2843 15.5903 17.908 15.782C17.4802 16 16.9201 16 15.8 16H5.12132L6.12132 15H15.8C16.3766 15 16.7488 14.9992 17.0322 14.9761C17.3038 14.9539 17.4045 14.9162 17.454 14.891C17.6422 14.7951 17.7951 14.6422 17.891 14.454C17.9162 14.4045 17.9539 14.3038 17.9761 14.0322C17.9992 13.7488 18 13.3766 18 12.8V8H13.1213L15.1213 6Z",
    fill: "#202635"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 12.5,
    r: 1.5,
    fill: "#202635"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 1.5,
    fill: "#202635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1L1 18",
    stroke: "#202635",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.20657022.svg";
export { ForwardRef as ReactComponent };